import React from 'react';
import cn from 'classnames';
import { wpToCF } from '../../utils/data/cdn';
import styles from './styles.module.css';

interface Props {
  title: string;
  image: string;
  link: string;
  excerpt: string;
  className?: string;
}

const ArticleSummaryThumbnail = ({
  title,
  className,
  image,
  link,
  excerpt
}: Props) => {
  const href = link.replace(process.env.UI_URL!, '');
  const imageStyles = {
    backgroundImage: `url(${wpToCF(image)})`
  };
  return (
    <div className={cn(className, 'relative')}>
      <div className='flex flex-col h-full'>
        <a href={href}>
          <div
            className={`shrink-0 bg-cover ${styles.image}`}
            style={imageStyles}
          />
        </a>
        <div
          className={`relative flex-grow bg-abn-gray-light w-full p-2 flex flex-col text-left sm:text-center`}
        >
          <h3 className='mb-2 block flex-shrink-0 mb-2 text-abn-red font-bold sm:font-normal text-l uppercase sm:normal-case'>
            <a href={href}>{title}</a>
          </h3>
          <p>{excerpt}</p>
          <p>
            <a href={href} className='text-abn-red'>
              Read more →
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ArticleSummaryThumbnail;
